// extracted by mini-css-extract-plugin
module.exports = {"tabsList":"SidebarTabs-moduletabsList3TC","listItem":"SidebarTabs-modulelistItem2Xo","activeTab":"SidebarTabs-moduleactiveTabFMf","mini":"SidebarTabs-modulemini3wj"};